"use strict";

var curryN = require('../function/curryN');
/**
 * Creates an array of values by running each element in list through fn. The fn is invoked with three arguments:
 * (value, index, arr).
 *
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} arr The list to be iterated over.
 * @return {Array} The new list.
 * @example
 *
 *      var double = x => x * 2;
 *
 *      map(double, [1, 2, 3]); //=> [2, 4, 6]
 */
module.exports = curryN(2, function (fn, arr) {
  if (arr === void 0) {
    arr = [];
  }
  var len = arr.length;
  var result = new Array(len);
  for (var i = 0; i < len; i++) {
    result[i] = fn(arr[i], i, arr);
  }
  return result;
});